export const SET_EXISTANT_CLAIMS: string = 'SET_EXISTANT_CLAIMS';
export const REQUEST_EXISTANT_CLAIMS: string = 'REQUEST_EXISTANT_CLAIMS';
export const REQUEST_VALIDATE_EXISTING_CLAIM__DOCUMENTS: string =
  'REQUEST_VALIDATE_EXISTING_CLAIM_DOCUMENTS';

export const DOCUMENT_STATUS = {
  VALIDATED: 'VALIDATED',
  REJECTED: 'REJECTED',
  TO_VALIDATE: 'TO_VALIDATE',
};

export const DOCUMENT_DECISION_VALUES: { [key: string]: string } = {
  VALIDATED: DOCUMENT_STATUS.VALIDATED,
  REJECTED: DOCUMENT_STATUS.REJECTED,
};

export const DOCUMENTS_PANEL = {
  PENDING_VALIDATION: 0,
  VALIDATED: 1,
  REJECTED: 2,
};

export const DOCUMENT_URL_STATUS = {
  VALIDATED: 'validated',
  REJECTED: 'rejected',
  TO_VALIDATE: 'to-validate',
};
